import _ from 'lodash';
import Vue from 'vue';

export default {
    async initProject(store, project) {
        let commit = store.commit;
        let info = project;

        if(!info || !info.project_id) {
            info = await jzlWebApi.project.getCurrentProject();
        }

        if(!info || !info.project_id) return;

        if(project) commit('INIT_CURRENT_PROJECT', info);
    },
    async initLoginUser (store, loginInfo) {
        let commit = store.commit;
        let info = loginInfo;

        if(!info || !info.admin) {
            info = await jzlWebApi.admin.getLoginAdmin();
        }

        if(!info || !info.admin) return;

        let admin = _.get(info, 'admin');
        let project = _.get(info, 'project');
        let customer = _.get(info, 'customer');
        let token = _.get(info, 'token');
        let loginType = _.get(info, 'loginType');

        if(admin) commit('INIT_LOGIN_USER', admin);
        if(project) commit('INIT_CURRENT_PROJECT', project);
        if(customer) commit('INIT_LOGIN_CUSTOMER', customer);
        if(loginType) commit('INIT_LOGIN_TYPE', customer);
        // if(token) commit('INIT_TOKEN', token);
        // this.$utils.setToken(token);
        // this.initToken({ commit }, token);
        if(token) await store.dispatch('initToken', token);
    },
    initLoginCust: async ({ commit }, loginInfo) => {
        let info = loginInfo;

        if(!info || !info.customer) {
            info = await jzlWebApi.admin.getLoginCust();
        }

        if(!info || !info.admin) return;

        let admin = _.get(info, 'admin');
        let project = _.get(info, 'project');
        let customer = _.get(info, 'customer');
        let token = _.get(info, 'token');
        let loginType = _.get(info, 'loginType');

        if(admin) commit('INIT_LOGIN_USER', admin);
        if(project) commit('INIT_CURRENT_PROJECT', project);
        if(customer) commit('INIT_LOGIN_CUSTOMER', customer);
        if(loginType) commit('INIT_LOGIN_TYPE', customer);
        this.initToken({ commit }, token);
    },
    initToken({ commit }, token) {
        if(!token) return;
        commit('INIT_TOKEN', token);
        //this.$utils.setToken(token);
        if(Vue.prototype.$utils && Vue.prototype.$utils.setToken) {
            Vue.prototype.$utils.setToken(token);
        }
    },
    changeProject: ({ commit }, project) => {
        commit('CHANGE_PROJECT', project);
    },
    menuToggle: ({ commit }, val) => {
        commit('CHANGE_MENUCOLLAPSE', val);
    },
    dyncCompLoadedTag: ({ commit }, domain) => {
        commit('DYNC_COMP_LOADED_TAG', domain);
    },
    getGroupsAndContentsByParentId: async ({ commit }, gid) => {
        let data = await jzlWebApi.admin.getAdminMenuByParentGroup(gid);
        return data;
    },
    changeMainMenu: ({ commit }, mainMenu) => commit('CHANGE_MAIN_MENU', mainMenu),
    initMenus: async ({ commit }, pid) => {
        let menus = await jzlWebApi.menu.getSubMenuTree(-1, 3);
        // 排序优先级：是否首页在最前(多个根据序号) > 目录 > 页面(多个根据序号)
        let dftMenus = _.filter(menus, m => {
            return !m.group_id && m.content_id && m.is_default_menu === 1;
        });
        let groups = _.filter(menus, m => {
            return m.group_id;
        });

        let normalMenus = _.filter(menus, m => {
            return !m.group_id && m.content_id && m.is_default_menu !== 1;
        });

        let realMenus= _.concat(dftMenus, groups, normalMenus);
        if(realMenus) {
            commit('INIT_MENUS', realMenus);
        }
    },
    changeSubGroups: ({ commit }, subGroups) => {
        commit('CHANGE_SUBGROUPS', subGroups);
    },
    initLayout: async ({ commit }, pid) => {
        let config = await jzlWebApi.project.getProjectLayoutConfig(pid);
        let layoutMgr = _.get(config, "layoutMgr.attr_value");
        let layoutH5 = _.get(config, "layoutH5.attr_value");
        let layoutWeb = _.get(config, "layoutWeb.attr_value");
        let clientType = null;
        let layout = null;

        if(Vue.prototype.$utils && Vue.prototype.$utils.getClientType) {
            clientType = Vue.prototype.$utils.getClientType();
        }

        if(clientType === 'h5') {
            layout = layoutH5;
        } else if(clientType === 'web' || clientType === 'pc') {
            layout = layoutWeb;
        } else if(clientType === 'mgr') {
            layout = layoutMgr;
        }

        if(layout) {
            let compDefs = layout.split("/");

            if(compDefs && compDefs.length >= 2) {
                commit('INIT_LAYOUT', {
                    compLib: compDefs[0],
                    compName: compDefs[1]
                })
            }
        }
    }
}
